import { render, staticRenderFns } from "./chat-item-doctor.vue?vue&type=template&id=6026472a"
import script from "./chat-item-doctor.vue?vue&type=script&lang=js"
export * from "./chat-item-doctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports